import {Component, Inject, LOCALE_ID, OnInit} from '@angular/core';
import {AuthService} from '../service/auth.service';
import {UrlHelper} from '../helper/url.helper';
import {ActivatedRoute, Router} from '@angular/router';
import {LanguageSwitchComponent} from '../common/language-switch/language-switch.component';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {

  private readonly localeOverride;

  constructor(private authService: AuthService,
              private router: Router,
              @Inject(LOCALE_ID) private locale: string,
              route: ActivatedRoute) {
    this.localeOverride = route.snapshot.queryParamMap.get(LanguageSwitchComponent.MANUAL_LOCALE_PARAM) === 'true';
  }

  async ngOnInit() {
    if (!this.localeOverride) {
      const user = await this.authService.getUser();
      if (user && user.locale && user.locale !== this.locale) {
        LanguageSwitchComponent.switchLanguage(user.locale as string);
      }
    }

    const session = await this.authService.getSession();

    if (session && session.isValid()) {
      let url;

      if (!session.role) {
        url = UrlHelper.ROLE_SELECT_PATH;
      } else if (session.isAdmin()) {
        url = UrlHelper.COMPETITIONS_LIST_PATH;
      } else if (session.isParticipant()) {
        url = UrlHelper.CONTESTS_AVAILABLE_PATH;
      } else if (session.isHost()) {
        url = UrlHelper.CONTESTS_MANAGE_PATH;
      } else if (session.isCoordinator() || session.isTeacher()) {
        url = UrlHelper.STUDENTS_PATH;
      } else if (session.isStudent()) {
        url = UrlHelper.CONTESTS_HISTORY_PATH;
      } else {
        url = UrlHelper.PROFILE_DETAILS_PATH;
      }

      await this.router.navigate([url]);
    } else {
      await this.router.navigate([UrlHelper.SIGN_IN_PATH], {replaceUrl: true});
    }
  }

}
